import React, {Component} from 'react';
import './footer.css';

export default class Footer extends Component{
  render(){
    return (
      <footer>
        <p>&copy; Bramz 2026</p>
      </footer>
    )
  }
}